import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/fleet-task-instant',
    params: params,
  })
  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task-instant/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/fleet-task-instant',
    data,
  })

  return response?.data
}

export const update = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `/fleet-task-instant/${fleetTaskId}`,
    data,
  })

  return response?.data
}

export const transition = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task-instant/${fleetTaskId}/transition`,
    data,
  })

  return response?.data
}

export const bulkTransition = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL: process.env.VUE_APP_API_BFF_URL,
    url: `/fleet-task-instant/transition`,
    data,
  })

  return response?.data
}

export const bulkTransitionV2 = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task-instant/transition`,
    data,
  })

  return response?.data
}

export const deleteMany = async (data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task-instant/delete`,
    data,
  })

  return response?.data
}

export const getPoints = async (id, params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task-instant/${id}/point`,
    params,
  })

  return response?.data
}

export const storePoint = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/fleet-task-instant/${fleetTaskId}/point`,
    data,
  })

  return response?.data
}

export const updatePoint = async (fleetTaskId, pointId, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `/fleet-task-instant/${fleetTaskId}/point/${pointId}`,
    data,
  })

  return response?.data
}

export const deletePoint = async (fleetTaskId, pointId) => {
  const response = await apiClientV2({
    method: 'DELETE',
    baseURL,
    url: `/fleet-task-instant/${fleetTaskId}/point/${pointId}`,
  })

  return response?.data
}

export const optimize = async (fleetTaskId) => {
  const response = await apiClientV2({
    method: 'PUT',
    baseURL,
    url: `/fleet-task-instant/${fleetTaskId}/optimize`,
  })

  return response?.data
}

export const calculateSchedule = async (fleetTaskId) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/fleet-task-instant/${fleetTaskId}/calculate`,
  })

  return response?.data
}

export const getListHistory = async (fleetTaskId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task-instant/${fleetTaskId}/history?type=status`,
  })

  return response?.data
}

export const track = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task-instant/track/${id}`,
  })

  return response?.data
}

export const getPointDetail = async (id, pointId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task-instant/${id}/point/${pointId}`,
  })

  return response?.data
}

export const uploadAttachments = async (id, pointId, data) => {
  const formData = new FormData()

  data.forEach((file) => {
    formData.append('files', file)
  })

  const response = await apiClientV2({
    baseURL,
    method: 'PUT',
    url: `/fleet-task-instant/${id}/point/${pointId}/attachment`,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })

  return response?.data
}

export const duplicate = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/fleet-task-instant/${id}/duplicate`,
    data,
  })

  return response?.data
}

export const getLogDetail = async (id, logId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/fleet-task-instant/${id}/log/${logId}`,
  })

  return response?.data
}

export const uploadDriverAttachments = async (fleetTaskId, data) => {
  const response = await apiClientV2({
    method: 'PUT',
    baseURL,
    url: `/fleet-task-instant/${fleetTaskId}/driver-attachment`,
    data,
  })

  return response?.data
}
